import { useQuery } from "@tanstack/react-query";

import { getTeamMemberFromInviteId } from "~/providers/api";

export const useGetTeamMemberFromInviteId = (invitationId?: string) => {
  const { data: teamMemberFromInviteId, isFetching } = useQuery({
    queryKey: ["getTeamMemberFromInviteId", invitationId],
    queryFn: () => getTeamMemberFromInviteId(invitationId ?? ""),
    enabled: !!invitationId,
  });

  return {
    teamMemberFromInviteId,
    isFetching,
  };
};
